// XXX: ONE source for the completion card-override option keys. These are
// XXX: DEPENDENCY-REFERENCE keys: a rename that misses
// XXX: helpers/component-reference-keys.js or src/Models/Studio/DcDependencyWalker.php
// XXX: silently drops the bound component from the compiled closure. The element
// XXX: then renders InvalidElement on staging while painting fine on the builder
// XXX: canvas, because the canvas reads a GLOBAL cumulative element registry and
// XXX: the production renderer does not. That divergence is task #44.
// XXX: CJS on purpose: the plain-node studio suite requires this, and CI runs
// XXX: node 20 which cannot require() an ES module.
// XXX: options/completion-card-variant.js asserts its option classes derive
// XXX: exactly these keys, so the two can never drift.
const COMPLETION_CARD_OPTION_KEY_NOT_STARTED = "completion-card-variant-not-started";
const COMPLETION_CARD_OPTION_KEY_STARTED = "completion-card-variant-started";
const COMPLETION_CARD_OPTION_KEY_COMPLETE = "completion-card-variant-complete";

const COMPLETION_CARD_CONTEXT_BINDINGS_OPTION_KEY = "completion-card-context-bindings";

const COMPLETION_CARD_OPTION_KEYS = [
  COMPLETION_CARD_OPTION_KEY_NOT_STARTED,
  COMPLETION_CARD_OPTION_KEY_STARTED,
  COMPLETION_CARD_OPTION_KEY_COMPLETE,
];

// Element types whose rendering consults the publication-level completion slots.
// The dependency walker gates its slot lookup on these so a page with no
// completion element does not drag six extra compiled bundles.
const COMPLETION_ELEMENT_TYPES = ["CompletionStatus", "CompletionToggle"];

module.exports = {
  COMPLETION_CARD_OPTION_KEY_NOT_STARTED,
  COMPLETION_CARD_OPTION_KEY_STARTED,
  COMPLETION_CARD_OPTION_KEY_COMPLETE,
  COMPLETION_CARD_OPTION_KEYS,
  COMPLETION_CARD_CONTEXT_BINDINGS_OPTION_KEY,
  COMPLETION_ELEMENT_TYPES,
};
